import axiosInstance from "../utils/axios";

export type CampaignFilters = {
    ageMin?: number;
    ageMax?: number;
    gender?: string;
    totalSpendMin?: number;
    lastVisitAfter?: string;
    nhsEligible?: boolean;
    postcode?: string;
};

export type LaunchCampaignData = {
    name: string;
    type: 'SMS' | 'Email';
    filters: CampaignFilters;
    template: {
        subject?: string;
        body: string;
    };
};

export class MarketingService {
    launchCampaign(data: LaunchCampaignData) {
        return axiosInstance.post(`/campaigns/launch`, data);
    }

    getCampaigns() {
        return axiosInstance.get(`/campaigns`);
    }
}
